import axios from 'axios';
import RestService from '../../helpers/RestService';
import moment from 'moment';
import {toastr} from 'react-redux-toastr'

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export function getFolders() {
  return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/slider-folders/get');

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_SLIDER_FOLDERS', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_SLIDER_FOLDERS', data: []})
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}

export function createFolder(body) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/slider-folder/post', {
        ...body, 
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'NEW_SLIDER_FOLDER', data: payload});
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'})      
    }
  }
}

export function createSlider(body) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/slider/post', {
        ...body, 
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'NEW_SLIDER_FOLDER_SLIDER', data: payload});
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'})      
    }
  }
}

export function updateSlider(body) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/slider/patch', {
        ...body, 
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'UPDATE_SLIDER_FOLDER_SLIDER', data: payload});
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'})      
    }
  }
}


export function copySlider(body) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/slider/copy', {
        ...body, 
      });

      if(data.errcode == 200) {
        return true;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'})      
    }
  }
}

export function deleteSlider(id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/slider/delete', {id});

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'DELETE_SLIDER_FOLDER_SLIDER', data: id});
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'})      
    }
  }
}


export function deleteFolder(id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/slider-folder/delete', { id });

      if(data.errcode == 200) {
        dispatch({type: 'DELETE_SLIDER_FOLDER', data: id});
        return data.payload;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
     
    } catch (error) {
      return Promise.reject({message: 'Bag request'})
    }
  }
}


export function updateFolder(body) {
  return async (dispatch) => {
    try {
      
      const {data} = await axios.post('/api/slider-folder/patch', {
        ...body, 
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'UPDATE_SLIDER_FOLDER', data: payload});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'}) 
    }
  }
}


export function setFolderItem(data) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_SLIDER_FOLDER', data})
      return data;
    } catch (error) {
    }
  }
}

export function getFolderSlider(id = 0, not_loader=false) {
  return async (dispatch) => {
    try {
      if(!not_loader){
        dispatch({type: 'SET_SLIDER_FOLDER_SLIDERS_LOADED', data: false});
      }
      const {data} = await axios.post('/api/slider-folder/sliders', {id});

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_SLIDER_FOLDER_SLIDERS', data: payload});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
    }
  }
}




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Sliders/actions.js